import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	configure: {
		id: 'servicedesk.channels-jsd.channels.chat.configure',
		defaultMessage: 'Configure',
		description: 'Configure a channel',
	},
	configureLabelDescriptive: {
		id: 'servicedesk.channels-jsd.channels.chat.configure.label-descriptive',
		defaultMessage: 'Configure chat channel',
		description: 'Configure a chat channel',
	},
	chatLabel: {
		id: 'servicedesk.channels-jsd.channels.chat.chat-label',
		defaultMessage: 'CHAT',
		description: 'chat label',
	},
	label: {
		id: 'servicedesk.channels-jsd.channels.chat.label',
		defaultMessage: 'Chat',
		description: 'chat label',
	},
	chatDescription: {
		id: 'servicedesk.channels-jsd.channels.chat.chat-description',
		defaultMessage: 'Create issues from chat channels',
		description: 'chat description',
	},
	chatDescriptionIssueTermRefresh: {
		id: 'servicedesk.channels-jsd.channels.chat.chat-description-issue-term-refresh',
		defaultMessage: 'Create work items from chat channels',
		description: 'chat description',
	},
	chatInactiveLabel: {
		id: 'servicedesk.channels-jsd.channels.chat.chat-inactive-label',
		defaultMessage: 'INACTIVE',
		description:
			'Status of the chat configuration, states if the project has chat enabled or connected for the the customers',
	},
	chatConnectedLabel: {
		id: 'servicedesk.channels-jsd.channels.chat.chat-connected-label',
		defaultMessage: 'CONNECTED',
		description:
			'Status of the chat configuration, states if the project has chat enabled or connected for the the customers',
	},
	chatOff: {
		id: 'servicedesk.channels-jsd.channels.chat.chat-off',
		defaultMessage: 'Off',
		description:
			'Status of the chat configuration, states if the project has chat enabled or connected for the customers',
	},
});
